import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import Backdrop from "../Backdrop";
import { resetUserAccountDetails } from "../../redux/actions";
import theme from "../../theme/theme";
import { analytics } from "../../analytics";
import Cookies from "universal-cookie";

const cookies = new Cookies();
let intervalId;

const BodyWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalBody = styled.div`
  max-width: 400px;
  width: 100%;
  background-color: white;
  padding: 40px 40px;
  border-radius: 15px;
  text-align: center;
  position: absolute;
  z-index: 1000;

  @media (max-width: 480px) {
    width: 80%;
    margin: auto;
    padding: 20px 20px;
  }

  .headerMessage {
    font-weight: 700;
    font-size: 32px;
    color: ${theme.colors.primaryStrong2X};

    .crossButton {
      float: right;
      font-size: 20px;
      cursor: pointer;

      @media (max-width: 480px) {
        font-size: 18px;
      }
    }

    @media (max-width: 480px) {
      font-size: 18px;
    }
  }

  .subHeaderMessage {
    margin-top: 20px;
    // font-weight: 700;
    font-size: 17px;
    color: ${theme.colors.primaryStrong2X};

    @media (max-width: 480px) {
      font-size: 14px;
    }
  }

  .stayLoginButton {
    border: none;
    background-color: ${theme.colors.primaryStrong2X};
    color: white;
    margin-top: 30px;
    padding: 10px 50px;
    font-weight: 700;
    font-size: 20px;
    border-radius: 5px;
    cursor: pointer;
  }

  .logoutButton {
    margin-top: 10px;
    border: none;
    cursor: pointer;
    background-color: transparent;
    color: ${theme.colors.primaryStrong2X};
  }
`;

const TimeoutModal = (props) => {
  const [countDown, setCountDown] = useState(60);
  const history = useHistory();
  const dispatch = useDispatch();

  const { userAccountDetails } = useSelector((state) => state.user);

  useEffect(() => {
    let intervalId = setInterval(() => {
      if (countDown > 0) setCountDown(countDown - 1);
    }, 1000);
    return () => {
      clearInterval(intervalId);
    };
  });

  useEffect(() => {
    if (countDown === 0) {
      logOut();
    }
  }, [countDown]);

  const logOut = () => {
    analytics.track("Signed Out", {
      userId: userAccountDetails?.id || "",
    });
    clearInterval(intervalId);
    cookies.remove("accessToken");
    let userType = userAccountDetails?.userType;
    dispatch(resetUserAccountDetails());
    if (userType === "Investor") history.push("/");
    else history.push("/advisor/login");
    props.setIsTimeOutModalVisible(false);
  };

  return (
    <Backdrop>
      <BodyWrapper>
        <ModalBody>
          <div className="headerMessage">Still there?</div>
          <div className="subHeaderMessage">
            You will be automatically logged out in {countDown}
          </div>
          <div>
            <button
              className="stayLoginButton"
              onClick={() => {
                clearInterval(intervalId);
                props.setIsTimeOutModalVisible(false);
              }}
            >
              Yes, stay logged in
            </button>
          </div>
          <button className="logoutButton" onClick={logOut}>
            Log out
          </button>
        </ModalBody>
      </BodyWrapper>
    </Backdrop>
  );
};

export default TimeoutModal;
